import { useSelector } from 'store/hooks/useSelector'
import { selectDawShowTreatAndAdd } from 'store/flags/FlagsSelectors'

// daw_show_treat_and_add is a Remote Config JSON array of provider emails.
// Empty array => nobody; a provider's email present in the array => enabled.
export function useDawShowTreatAndAdd(): boolean {
  const email = useSelector((state) => state.waitingRoomReducer.providerProfile.Email)
  const emails = useSelector(selectDawShowTreatAndAdd)
  if (!email || !Array.isArray(emails)) {
    return false
  }
  const normalizedEmail = email.toLowerCase()
  return emails.some((entry) => entry?.toLowerCase() === normalizedEmail)
}
